function r(r) {
  var n = ("" + (r || "")).charCodeAt(0);
  return !(!r || Number.isNaN(n) || !(n >= 65 && n <= 90 || n >= 97 && n <= 122 || n >= 48 && n <= 57));
}

var n = [{
  closeTag: "</strong>",
  openTag: "<strong>",
  wildcard: "*"
}, {
  closeTag: "</i>",
  openTag: "<i>",
  wildcard: "_"
}, {
  closeTag: "</s>",
  openTag: "<s>",
  wildcard: "~"
}];

function e(e, t) {
  return function (n, e) {
    return e.reduce(function (n, e) {
      return function (n, e) {
        var t = function (n, e) {
          for (var t = [], o = 0; o < n.length; o += 1) {
            if (n[o] === e) {
              if (t.length % 2) {
                if (" " === n[o - 1] || r(n[o + 1])) break;
                t.push(o);
              } else {
                if (void 0 === n[o + 1] || " " === n[o + 1] || r(n[o - 1])) break;
                t.push(o);
              }
            } else 10 === n[o].charCodeAt(0) && t.length % 2 && t.pop();
          }

          return t.length % 2 && t.pop(), t;
        }(n, e.wildcard);

        return function (r, n, e) {
          var t = 0;
          return n.forEach(function (n, o) {
            var a = o % 2 ? e.closeTag : e.openTag,
                c = n;
            r = r.substr(0, c += t) + a + r.substr(c + 1), t += a.length - 1;
          }), r;
        }(n, t, e);
      }(n, e);
    }, n).replace(/\n/gi, "<br>");
  }(e, t || n);
}

export { e as format, n as whatsappRules };